import VueRouter from 'vue-router'
import swal from 'sweetalert2';

const router = new VueRouter()

export class SessionService {
    handleErrorResponse(error) {
        let currentPathName = router.history.current.path;
        if (error.response.status === 401 && !window.location.href.includes("login")) {
            localStorage.removeItem('ACCESS_TOKEN')
            swal('Greška', 'Istekla je sesija.', 'error');
            window.location = '/#/login';
        } else {
            return Promise.reject(error);
        }
    }
    handleLoginErrorResponse(error) {
        if (error.response.status === 401 && window.location.href.includes("login")) {
            if(error.response != null && error.response.data != null && error.response.data.localized_error_message != null){
                swal('Greška', error.response.data.localized_error_message, 'error');
            }else{
                swal('Greška', 'Neispravni podaci', 'error');
            }

        } else {
            return Promise.reject(error);
        }
    }

    handleAcceptTermsErrorResponse(error) {
        swal('Greška', 'Morate da prihvatite uslove korišćenja ukoliko želite da trenirate.', 'error');
        window.location = '/#/accept-terms';
        return Promise.reject(error);
    }
}


// WEBPACK FOOTER //
// ./src/services/SessionService.js